var map = {
	"./Battery-low-partner.png": "aa4e",
	"./Chart-pie-alt-partner.png": "0f98",
	"./Gamepad-partner.png": "920c",
	"./User-partner.png": "684e",
	"./balance.png": "c7dc",
	"./budget-bg.png": "c7b1",
	"./competitions.png": "f1cb",
	"./done-all.png": "4761",
	"./earnings.png": "ec5b",
	"./forex-trading-background_52683-42357.png": "e04b",
	"./money.png": "b6c5",
	"./money_1.png": "40a5",
	"./tickets.png": "425a",
	"./trades-lost.png": "c4a0",
	"./trades-won.png": "e8bc",
	"./user.png": "e0d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6530";